document.addEventListener("DOMContentLoaded", function () {
  const stickyAtc = document.querySelector(".sticky-atc");
  const mainAtc = document.querySelector(".atc_main");

  if (!stickyAtc || !mainAtc) return;

  // HARD EXIT ON DESKTOP
  if (window.matchMedia("(min-width: 769px)").matches) {
    stickyAtc.style.display = "none";
    return;
  }

  // Mobile only below
  const atcOffsetTop = mainAtc.offsetTop;

  function toggleSticky() {
    const scrollY = window.scrollY || window.pageYOffset;
    const atcRect = mainAtc.getBoundingClientRect();

    // Above ATC -> never show
    if (scrollY < atcOffsetTop) {
      stickyAtc.style.display = "none";
      return;
    }

    // Past ATC and ATC fully out of view -> show
    if (atcRect.bottom <= 0) {
      stickyAtc.style.display = "block";
    } else {
      stickyAtc.style.display = "none";
    }
  }

  // Ensure hidden before any scroll
  stickyAtc.style.display = "none";

  window.addEventListener("scroll", toggleSticky, { passive: true });
});